export default "__VITE_ASSET__cd15b15f__"